export default "__VITE_ASSET__BfnfH9hg__"